<template>
  <v-dialog v-model="dialog" class="processing-dialog" :max-width="isMobile ? '332px' : '614px'">
    <v-progress-linear class="py-1" rounded indeterminate color="marca-0-l30" />
    <v-card class="processing-card">
      <span class="processing-title">Processando oferta</span>
      <div class="processing-content">
        <div class="d-flex flex-column gap-2">
          <span class="cinza-d10-text">{{ message }}</span>
          <span class="cinza-d10-text">Você pode retornar a página de ofertas enquanto aguarda.</span>
        </div>

        <div class="processing-buttons">
          <mf-button label="Voltar" @click="goBack" />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ProcessingDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    close() {
      this.dialog = false
    },
    goBack() {
      this.dialog = false
      this.$emit('go-back')
    },
  },
}
</script>

<style lang="scss" scoped>
.processing-dialog {
  height: 378px;

  @media screen and (max-width: $xs-breakpoint) {
    height: 492px;
  }
}

.processing-card {
  padding: 20px 18px;

  .processing-title {
    font-size: 22px;
    font-weight: bold;
    color: $cinza-d10;

    @media screen and (max-width: $xs-breakpoint) {
      font-size: 20px;
    }
  }

  .processing-content {
    margin-top: 20px;
    font-size: 14px;

    .cinza-d10-text {
      color: $cinza-d10;
    }

    .processing-buttons {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      gap: 16px;
    }
  }
}

::v-deep .v-dialog {
  border: 1px solid $marca-0-l30;
  border-radius: 8px;
  box-shadow: 0px 2px 20px 0px #0000002f;
}
</style>
